// extracted by mini-css-extract-plugin
export default {"container":"FVVo8","input":"gDqVI"};